export const DEFAULT_HELMET = "Data Bridges"
export const API_BASE_URL = process.env.REACT_APP_API_URL

const DEFAULT_AIMS_API_URL =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "http://localhost:7051/"
    : "https://aims.dev.aws-databridges.vam.wfp.org/"
export const AIMS_API_BASE_URL = process.env.REACT_APP_AIMS_API_URL || DEFAULT_AIMS_API_URL
export const GET_ITEM_LIMIT = 10
export const MARKET_MODULE = 1
export const MFI_MODULE = 2
export const GORP_MODULE = 3
export const RPME_MODULE = 4
export const HH_MODULE = 5
export const AIMS_MODULE = 6
export const SYSTEM_ADMIN_ROLE = "System Administrator"
export const ADMIN_ROLE = "Administrator"
export const SUPERVISOR_ROLE = "Supervisor"
export const CONTRIBUTOR_ROLE = "Contributor"
export const VISITOR_ROLE = "Visitor"

export const regionList = [
  { value: 1, label: "RBB" },
  { value: 5, label: "RBC" },
  { value: 6, label: "RBD" },
  { value: 7, label: "RBJ" },
  { value: 8, label: "RBN" },
  { value: 9, label: "RBP" },
  { value: 10, label: "Other" },
]

export const visibilityList = [
  { value: 1, label: "HQ" },
  { value: 2, label: "Region" },
  { value: 3, label: "CO" },
]

export const getFeaturesList = (defaultAccess = true) => ({
  viewList: defaultAccess,
  searchList: defaultAccess,
  addNew: defaultAccess,
  details: defaultAccess,
  all: defaultAccess,
  limited: defaultAccess,
  delete: defaultAccess,
  approve: defaultAccess,
  reject: defaultAccess,
  edit: defaultAccess,
  review: defaultAccess,
})

export const mfiRmpeModulesPermissions = {
  [SYSTEM_ADMIN_ROLE]: {
    surveys: getFeaturesList(),
    xlsForms: { ...getFeaturesList(), pii: true },
    baseXLSForms: getFeaturesList(),
    users: getFeaturesList(),
    markets: getFeaturesList(),
    outliers: getFeaturesList(false),
    mappingSchema: getFeaturesList(false),
    alps: getFeaturesList(false),
    ccpucs: getFeaturesList(false),
  },
  [ADMIN_ROLE]: {
    surveys: getFeaturesList(),
    xlsForms: { ...getFeaturesList(), pii: false },
    baseXLSForms: { ...getFeaturesList(), addNew: false, edit: false, limited: false, delete: false },
    users: getFeaturesList(),
    markets: getFeaturesList(),
    outliers: getFeaturesList(false),
    mappingSchema: getFeaturesList(false),
    alps: getFeaturesList(false),
    ccpucs: getFeaturesList(false),
  },
  [SUPERVISOR_ROLE]: {
    surveys: { ...getFeaturesList(), delete: false },
    xlsForms: { ...getFeaturesList(), delete: false, pii: false },
    baseXLSForms: getFeaturesList(false),
    markets: getFeaturesList(false),
    users: getFeaturesList(false),
    outliers: getFeaturesList(false),
    mappingSchema: getFeaturesList(false),
    alps: getFeaturesList(false),
    ccpucs: getFeaturesList(false),
  },
  [CONTRIBUTOR_ROLE]: {
    surveys: { ...getFeaturesList(), approve: false, reject: false, delete: false, edit: false },
    xlsForms: { ...getFeaturesList(), approve: false, reject: false, delete: false, pii: false, edit: false },
    baseXLSForms: getFeaturesList(false),
    markets: getFeaturesList(false),
    users: getFeaturesList(false),
    outliers: getFeaturesList(false),
    mappingSchema: getFeaturesList(false),
    alps: getFeaturesList(false),
    ccpucs: getFeaturesList(false),
  },
  [VISITOR_ROLE]: {
    surveys: { ...getFeaturesList(false) },
    xlsForms: { ...getFeaturesList(), addNew: false, limited: false, delete: false, pii: false, edit: false },
    baseXLSForms: getFeaturesList(false),
    markets: getFeaturesList(false),
    users: getFeaturesList(false),
    outliers: getFeaturesList(false),
    mappingSchema: getFeaturesList(false),
    alps: getFeaturesList(false),
    ccpucs: getFeaturesList(false),
  },
}

// 1=MarketPrices 2=MFI 3=GORP 4=RPME
// ccpucs => Commodities/Categories/Price Types/Units of Measure/Currecies/Series
export const permissionsRules: any = {
  [MFI_MODULE]: mfiRmpeModulesPermissions,
  [RPME_MODULE]: mfiRmpeModulesPermissions,
  [GORP_MODULE]: {
    [SYSTEM_ADMIN_ROLE]: getFeaturesList(),
    [ADMIN_ROLE]: getFeaturesList(),
    [SUPERVISOR_ROLE]: getFeaturesList(),
    [CONTRIBUTOR_ROLE]: getFeaturesList(),
    [VISITOR_ROLE]: { ...getFeaturesList(), delete: false },
  },
  [MARKET_MODULE]: {
    [SYSTEM_ADMIN_ROLE]: {
      ccpucs: getFeaturesList(),
      alps: getFeaturesList(),
      markets: getFeaturesList(),
      outliers: getFeaturesList(),
      reports: getFeaturesList(),
      mappingSchema: getFeaturesList(),
      users: getFeaturesList(),
    },
    [ADMIN_ROLE]: {
      ccpucs: getFeaturesList(),
      alps: getFeaturesList(),
      markets: getFeaturesList(),
      outliers: getFeaturesList(),
      reports: getFeaturesList(),
      mappingSchema: getFeaturesList(),
      users: getFeaturesList(), // OLD = {...getFeaturesList(false), viewList: true, searchList: true}
    },
    [SUPERVISOR_ROLE]: {
      ccpucs: { ...getFeaturesList(false), viewList: true, searchList: true },
      alps: { ...getFeaturesList(false), viewList: true, searchList: true },
      markets: { ...getFeaturesList(false), viewList: true, searchList: true },
      outliers: getFeaturesList(false),
      reports: getFeaturesList(),
      mappingSchema: getFeaturesList(),
      users: getFeaturesList(false),
    },
    [CONTRIBUTOR_ROLE]: {
      ccpucs: { ...getFeaturesList(false), viewList: true, searchList: true },
      alps: { ...getFeaturesList(false), viewList: true, searchList: true },
      markets: { ...getFeaturesList(false), viewList: true, searchList: true },
      outliers: getFeaturesList(false),
      reports: { ...getFeaturesList(true), approve: false, reject: false, review: false },
      mappingSchema: getFeaturesList(),
      users: getFeaturesList(false),
    },
    [VISITOR_ROLE]: {
      ccpucs: { ...getFeaturesList(false), viewList: true, searchList: true },
      alps: { ...getFeaturesList(false), viewList: true, searchList: true },
      markets: { ...getFeaturesList(false), viewList: true, searchList: true },
      outliers: getFeaturesList(false),
      reports: { ...getFeaturesList(false), viewList: true, searchList: true },
      mappingSchema: { ...getFeaturesList(false), viewList: true, searchList: true },
      users: getFeaturesList(false),
    },
  },
  [HH_MODULE]: mfiRmpeModulesPermissions,
  [AIMS_MODULE]: {
    [SYSTEM_ADMIN_ROLE]: {
      assets: getFeaturesList(),
    },
    [ADMIN_ROLE]: {
      assets: { ...getFeaturesList(), all: false },
    },
    [SUPERVISOR_ROLE]: {
      assets: { ...getFeaturesList(), all: false },
    },
    [CONTRIBUTOR_ROLE]: {
      assets: { ...getFeaturesList(), all: false },
    },
    [VISITOR_ROLE]: {
      assets: { ...getFeaturesList(), all: false, addNew: false, limited: false, delete: false },
    },
  },
}

export enum SurveyStatus {
  IN_PROGRESS = 1,
  PENDING = 2,
  APPROVE = 3,
  REJECT = 4,
}

export enum XlsFormStatus {
  ValidationError = 400,
}

export enum DataBridgesApiKeyStatus {
  ENABLED = 1,
  DISABLED = 2,
}

export const formatDateTime: string = "DD-MM-YYYY HH:mm"
